import { Text, View } from "@react-pdf/renderer";
import { styles } from "./styles";
import { SinglePdfHeaderType } from "../GenericPdf/constant";
import {
  getBatchMarginValue,
  getMarginValue,
  handleHeaderDescriptionWidth,
  handleOthersWidth,
} from "../CommonPdfComponents/utils";
import { formatToShortDate } from "../../../../utils/commonFunctions";

type AppProps = {
  items: any;
  tableHeaders: SinglePdfHeaderType[];
};

const BatchSummaryInvoiceTableRow = ({ items, tableHeaders }: AppProps) => {

  const wrapText = (text: string, maxLen = 8) => {
    return text?.match(new RegExp(`.{1,${maxLen}}`, 'g'))?.join('\n') || '';
  };
  // commented for future use
  // const wrapText = (text: string, maxLen = 10) => {
  //   if (!text) return "";

  //   // If text already has a hyphen, split there and add line break only once
  //   if (text.includes("-")) {
  //     const parts = text.split("-");
  //     return parts.join("-\n");
  //   }

  //   // Else split into chunks normally
  //   return text.match(new RegExp(`.{1,${maxLen}}`, 'g'))?.join('\n') || '';
  // };
  const handleRows = () => {
    const finalItems = items?.map((item: any, index: number) => {
      return (
        <View key={index} style={styles.row}>
          {tableHeaders?.map((header: SinglePdfHeaderType) => {
            if (header?.column_value === "description") {
              return (
                <Text
                  style={{
                    ...styles.description,
                    paddingRight: getMarginValue(tableHeaders?.length),
                    paddingBottom: 1,
                    paddingLeft: "1px",
                    paddingTop: 1,
                    width: handleHeaderDescriptionWidth(tableHeaders?.length),
                    fontSize: "8px",
                  }}
                >
                  {item?.description_as_per_bill
                    ? item?.description_as_per_bill
                    : "-"}
                </Text>
              );
            } else if (header?.column_value === "no") {
              return (
                <Text
                  style={{
                    ...styles.no,
                    paddingBottom: 1,
                    paddingTop: 1,
                    fontSize: "8px",
                  }}
                >
                  {index + 1}
                </Text>
              );
            } else if (header?.column_value === "quantity") {
              return (
                <Text
                  style={{
                    ...styles.table_width,
                    paddingRight: "15px",
                    paddingLeft: "0.5px",
                    width: "8%",
                    ...styles.currencyFont,
                    paddingBottom: 1,
                    fontSize: "8px",
                  }}
                >
                  {item[header?.column_value]} {item?.unit ? item?.unit : ""}
                </Text>
              );
            } else if (header?.column_value === "batch_id") {
              return (
                <Text
                  style={{
                    ...styles.batch_id,
                    paddingRight: getBatchMarginValue(tableHeaders?.length),
                    paddingLeft: "0.5px",
                    // width: item?.batch_number?.label ? "12%" : "15%",
                    width: handleOthersWidth(tableHeaders?.length),
                    paddingBottom: 1,
                    fontSize: "8px",
                    wordWrap: "break-word"

                  }}
                >
                  {/* {wrapText(item?.batch_number?.label, 9)} */}
                  {item?.batch_number?.label ?
                    (item?.batch_number?.label.length >= 8 ? wrapText(item?.batch_number?.label, 8) : item?.batch_number?.label)
                    : "--/--"}
                  {"\n"}
                  {item?.batch_number?.manufacturing_date && (
                    <>
                      <Text style={{
                        ...styles.text,
                        color: "grey",
                      }}>Mfg:</Text>
                      <Text style={{
                        ...styles.text,
                        color: "grey",
                      }}>
                        {formatToShortDate(item?.batch_number?.manufacturing_date)}
                      </Text>
                    </>
                  )}
                  {"\n"}
                  {item?.batch_number?.expiry_date && (
                    <>
                      <Text style=
                        {{
                          ...styles.text,
                          color: "grey",
                        }}>Exp:</Text>
                      <Text style={{
                        ...styles.text,
                        color: "grey",
                      }}>
                        {formatToShortDate(item?.batch_number?.expiry_date)}
                      </Text>
                    </>
                  )}
                </Text>
              );
            } else {
              return (
                <Text
                  style={{
                    ...styles.table_width,
                    paddingRight:
                      header.column_value === "sku_code" ? "35px" : "35px",
                    paddingLeft: "1px",
                    width: handleOthersWidth(tableHeaders?.length),
                    ...styles.currencyFont,
                    paddingBottom: 1,
                    fontSize: "8px",
                  }}
                >
                  {header.column_value === "sku_code"
                    ? item[header?.column_value]?.label
                    : item[header?.column_value]?.toString()?.includes(".")
                      ? isNaN(+item[header?.column_value])
                        ? item[header?.column_value]
                        : (+item[header?.column_value])?.toFixed(2)
                      : item[header?.column_value]}
                </Text>
              );
            }
          })}
        </View>
      );
    });

    return finalItems;
  };

  return <View>{handleRows()}</View>;
};

export default BatchSummaryInvoiceTableRow;
